module.exports = __webpack_public_path__ + "img/junior-achievement-logo.9155ecb1.jpg";